import React from 'react';
import { Box, Container } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Page from 'src/components/Page';
import Breadcrumb from 'src/components/Breadcrumb';
import { selectBureauReportDetailCount, selectBureauReportDetailInfo } from 'src/store/selectors/bureauReportSelector';

import Toolbar from './Toolbar';
import BuroReportDetailList from './BuroReportDetailList';

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const BuroReportDetailView = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  
  const totalContracts = useSelector(selectBureauReportDetailCount);
  const reportInfo = useSelector(selectBureauReportDetailInfo);

  return (
    <Page className={classes.root} title={t('BUREAU_REPORTS.DETAIL_TITLE')}>
      <FadeIn transitionDuration={200}>
        <Container maxWidth={false}>
          <Breadcrumb doNotRedirectIndexList={[0]} />
          <Toolbar
            totalContracts={totalContracts}
            reportDate={reportInfo?.date}
            reportType={reportInfo?.type}
          />
          <Box mt={3}>
            <BuroReportDetailList />
          </Box>
        </Container>
      </FadeIn>
    </Page>
  );
};

export default BuroReportDetailView;
